import { render, staticRenderFns } from "./menu-collapse.vue?vue&type=template&id=22788a0a"
import script from "./menu-collapse.vue?vue&type=script&lang=js"
export * from "./menu-collapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22788a0a')) {
      api.createRecord('22788a0a', component.options)
    } else {
      api.reload('22788a0a', component.options)
    }
    module.hot.accept("./menu-collapse.vue?vue&type=template&id=22788a0a", function () {
      api.rerender('22788a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/basic-layout/menu-side/menu-collapse.vue"
export default component.exports